import RptTable from '../basic/table'

export default RptTable


// WEBPACK FOOTER //
// ./src/yxyweb/common/components/rpttable/index.jsx